import { ModalController } from '@ionic/angular';
import { I18ConfigService } from './../../../../../services/shared/I18-config.service';
import { Component, OnInit, Input } from '@angular/core';
import { count } from 'rxjs/operators';
import { MenuItemModel, CustomizationOptionSetModel } from 'src/app/models/customization-models';

@Component({
  selector: 'app-customization',
  templateUrl: './customization.component.html',
  styleUrls: ['./customization.component.scss'],
})
export class CustomizationComponent implements OnInit {
  @Input() menuItem: MenuItemModel;
  pagetitle: string;
  optionsList: CustomizationOptionSetModel[];
  currencyCode: string;
  veg = '../../../../assets/icon/veg.svg';
  nonveg = '../../../../assets/icon/nonveg.svg';
  addItemDisabled = false;
  priceMap = new Map();
  additionalPrice: number;
  menuItemPrice: number;
  itemTotal: number;
  selectedOptions: number[];
  selectedList: number[];
  stepcount: number;
  previousCatName: string;
  previousItemName: string;
  selectedOptionsSet: CustomizationOptionSetModel[][];
  isMultilevel: boolean;
  constructor(private i18ConfigService: I18ConfigService, private modalController: ModalController) {
    this.currencyCode = this.i18ConfigService.getCurrency();
    this.selectedOptions = [];
    this.selectedOptionsSet = [];
    this.stepcount = 1;
  }

  ngOnInit() {
  }
  // ionViewDidEnter() {
  ionViewWillEnter() {
    this.pagetitle = this.menuItem.title;
    if (typeof this.menuItem.options !== 'undefined') { // for multilevel customization like dominos case
      this.isMultilevel = true;
      if (this.menuItem.options.minConstraint === 1 && this.menuItem.options.maxConstraint === 1 && typeof this.menuItem.options.selectedRadio === 'undefined') {
        this.menuItem.options.selectedRadio = this.menuItem.options.values[0].id.toString();
      }
      this.optionsList = [this.menuItem.options];
    } else { // for singel level multiple customization like subway case
      this.addItemDisabled = true;
      this.optionsList = this.menuItem.optionsList || [] as CustomizationOptionSetModel[];
      this.selectedList = this.menuItem.optionList;
      this.menuItemPrice = parseFloat(this.menuItem.price);
      this.itemTotal = this.menuItemPrice || 0.00;
      this.optionsList.forEach((element, index) => {
        if (element.minConstraint === 1 && element.maxConstraint === 1) {
          if (typeof element.selectedRadio === 'undefined') {
            element.selectedRadio = element.values[0].id.toString();
          }
          this.optionsList.splice(index, 1);
          this.optionsList.splice(0, 0, element);
        }
      });
    }
  }

  checkBoxUpdate(optionItem, optionSetKey: number) {
    let checkboxCount = 0;
    this.optionsList[optionSetKey].values.forEach(element => {
      if (element.isChecked) {
        checkboxCount++;
      }
    });
    if (checkboxCount >= this.optionsList[optionSetKey].maxConstraint) {
      // disable checkbox avoid getting more inputs.
      this.optionsList[optionSetKey].disableAllCheckboxes = true;
      if (checkboxCount > this.optionsList[optionSetKey].maxConstraint) {
        optionItem.isChecked = false;
        return;
      }
    } else if (this.optionsList[optionSetKey].disableAllCheckboxes === true) {
      this.optionsList[optionSetKey].disableAllCheckboxes = false;
    }
    let key = 'optionItem_' + optionItem.id;
    if (optionItem.isChecked) {
      this.priceMap.set(key, optionItem.price);
    } else if (this.priceMap.has(key)) {
      this.priceMap.delete(key);
    }
    this.updateTotalPrice();
  }

  radioUpdated(optionSet) {
    if (typeof optionSet.selectedRadio !== 'undefined') {
      console.log('selected radio');
      optionSet.values.forEach((optionItem) => {
        if (optionItem.id === parseInt(optionSet.selectedRadio, 10)) {
          this.priceMap.set('optionSet_' + optionSet.id, optionItem.price);
        }
      });
    }
    this.updateTotalPrice();
  }

  updateTotalPrice() {
    this.additionalPrice = 0;
    if (this.priceMap.size > 0) {
      this.additionalPrice = Array.from(this.priceMap.values()).reduce((prev, nxt) => prev + nxt, 0);
      console.log(this.additionalPrice);
    }
    this.itemTotal = (this.menuItemPrice || 0) + this.additionalPrice;
  }

  submitCustomization() {
    this.updateSelectedOptions(false);
    this.modalController.dismiss({
      selectedMenuOptions: this.selectedOptions,
      additionalPrice: this.additionalPrice
    });
  }

  dismissModal() {
    this.modalController.dismiss();
  }

  changePreviousSelected() {
    this.optionsList = this.selectedOptionsSet[this.stepcount - 1];
    this.stepcount--;
    this.selectedOptions.pop();
    if (this.stepcount === 0) {
      this.dismissModal();
    }
  }
  continue() {
    let newOptionItem = this.updateSelectedOptions(true);
    this.selectedOptionsSet[this.stepcount] = this.optionsList;
    if (newOptionItem.minConstraint === 1 && newOptionItem.maxConstraint === 1 && typeof newOptionItem.selectedRadio === 'undefined') {
      newOptionItem.selectedRadio = newOptionItem.values[0].id.toString();
    }
    this.optionsList = [newOptionItem];
    this.stepcount++;
    if (this.stepcount === this.menuItem.optionsSteps) {
      this.addItemDisabled = true;
    }
  }

  private updateSelectedOptions(returnItem: boolean = false) {
    let optionListItem: CustomizationOptionSetModel = {} as CustomizationOptionSetModel;
    this.optionsList.forEach(optionItem => {
      if (typeof optionItem.selectedRadio !== 'undefined' || null || '') {
        this.selectedOptions.push(parseInt(optionItem.selectedRadio, 10));
        this.previousCatName = optionItem.name;
        if (returnItem) {
          optionItem.values.every(element => {
            if (element.id.toString() === optionItem.selectedRadio) {
              this.previousItemName = element.name;
              optionListItem = element.options;
              return false;
            }
            return true;
          });
        }
      } else if (optionItem.values && optionItem.values.length > 0) {
        optionItem.values.forEach(item => {
          if (item.isChecked) {
            this.selectedOptions.push(item.id);
          }
        });
      }
    });
    if (returnItem) {
      return optionListItem;
    }
  }
}
